<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="6"
        @click="(e) => { val.page = (e+2); $emit('next_page', val); }"
        :click_fnc="$localStorage.get('user').username.role==3"
		/>
        <selectInput
            @inputTxtFunc = "(e)=>{ set_val(e, 'status'); }"
            label="ثبت نتیجه ارزیابی"
            :flds="[
                {'id': '1','name': 'فعال', 'hidden': true},
                {'id': '10','name': 'پروفایل کامل/غیرفعال/در انتظار بررسی مدارک'},
                {'id': '2','name': 'پروفایل کامل/ غیرفعال/ ادمین'},
                {'id': '7','name': 'پروفایل ناقص با احراز هویت'},
                {'id': '0','name': 'ثبت نام بدون احراز هویت', 'hidden': true},
                {'id': '11','name': 'نقص مدارک ارزیابی'},
                {'id': '6','name': 'درخواست تغییر یا ارتقا', 'hidden': true},
                {'id': '3','name': 'بلاک شده‌ها', 'hidden': true},
                {'id': '12','name': 'رد شدها'},
                {'id': '13','name': 'در انتظار فعال سازی'},
                {'id': '5','name': 'حذف شدها', 'hidden': true}

            ]"
            :value="val.value.status"
        />
        <textareaInput
        :value="val.value.comment"
        @blurinputTxtFunc="(e)=>{ set_val(e, 'comment'); }"
        label="توضیحات"
        placeholder="توضیحات اپراتور در اینجا نوشته شود..."
        v-if="val.value.status == 11 || val.value.status == 12 "
        />
    <!-- ************************************************************* -->
    <br>
    <br>
    <br>
        <btn
            text=" ثبت "
            textClass="w-100 mt-3"
            @clickMe="sav_final()"
        />
	</div>
    <!-- ************************************************************* -->
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
    import selectInput from  "../../UI/input/selectInput.vue";
	import textareaInput from  "../../UI/input/textareaInput.vue";

	export default {
		name: 'wait_signup',
		data(){
			return {
                fld: ['status', 'comment']
			}
		},
		components: {
			btn,
            textareaInput,
			multi_step_progress,
            selectInput,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
            set_val(val, fild){
                if(val>0 || val != ''){
                    this.val.value[fild] = val;
                    if(this.$localStorage.get('user')) {
                        window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: val, id: this.val.id, admin: this.$localStorage.get('user')}, function () {}, "json");
                    } else {
                        window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: val, id: this.val.id}, function () {}, "json");
                    }
                }
            },
            sav_final(THIS=this){
                this.val.id = (this.val.id) ? this.val.id : this.val.value.id;
                for (let i = 0; i < this.fld.length; i++) {
                    if(this.$localStorage.get('user')) {
                        window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: this.fld[i] ,val: this.val.value[this.fld[i]], id: this.val.id, admin: this.$localStorage.get('user')}, function () {
                        }, "json");
                    } else {
                        window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: this.fld[i] ,val: this.val.value[this.fld[i]], id: this.val.id}, function () {
                        }, "json");
                    }
                   
                }
                    THIS.send_sms(THIS.val.value);
                    this.$router.go(-1);
            },
				stringToBase64(str) {
					let encodedStr = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
						(match, p1) => String.fromCharCode('0x' + p1)
					);
					return btoa(encodedStr);
				},
				//*************************************************************
            send_sms(val){
                let text = '';
                if(val.status==1){
                    text = " مدرس گرامی؛ \n حساب کاربری شما در ایزی تیک فعال شد! \n شما می توانید در حساب کاربری خود در قسمت 'مدیریت کلاس ها' نسبت به مشخص‌ نمودن زمان های تدریس خود اقدام کنید.\n \n ticket.siadat.net";
                }if(val.status==11){
                    text = "مدرس گرامی؛ \n وضعیت پروفایل شما به دلیل نقص مدارک به 'غیر فعال' تغییر پیدا کرد. لطفاً نسبت به تکمیل مدارک، در حساب کاربری خود اقدام نمایید.\n \n ticket.siadat.net";
                }if(val.status==2){
                    text = "مدرس گرامی؛ \n  وضعیت پروفایل شما به 'غیر فعال' تغییر پیدا کرد. به منظور کسب اطلاعات بیشتر، با پشتیبانی ایزی تیک تماس بگیرید. شماره تماس پشتیبانی 02188618512 \n \n ticket.siadat.net";
                }if(val.status==12){
                    text = "مدرس گرامی؛ \n متأسفانه وضعیت پروفایل شما به 'رد شده' تغییر پیدا کرد. به منظور کسب اطلاعات بیشتر با پشتیبانی ایزی تیک تماس بگیرید. \nپشتیبانی 02188618512 \n \n ticket.siadat.net";
                }
                text = this.stringToBase64(this.stringToBase64(text));
			window.$.post(window.sendSms, {token: this.$localStorage.get("user"), phn: val.mobile, txt: text }, function(){
				}, "json");
            },
		}
	}
</script>
<style>

</style>
